import React from 'react';
import style from './Partners.module.scss';

import AusIMMLogoImg from '../imgs/sponsors/AusIMM-Logo.png';
import CrownResortsImg from '../imgs/sponsors/Crown_Resorts_Foundation-logo.jpg';
import DWLogoImg from '../imgs/sponsors/DW Logo.png';
import FnpwImg from '../imgs/sponsors/FoundationForNationalParksAndWildlife-Logo.png';
import ImbLogoImg from '../imgs/sponsors/IMB-logo.png';
import ItsowelImg from '../imgs/sponsors/Itsowel-Logo.png';
import NSWGovLogoImg from '../imgs/sponsors/NSWGov_Logo_rgb-01.png';
import OehImg from '../imgs/sponsors/OEH.png';
import AboriginalCorpImg from '../imgs/sponsors/aboriginal-corp.png';
import ActHeritageImg from '../imgs/sponsors/act-heritage.jpg';
import ActGovLogoImg from '../imgs/sponsors/actgov-logo.png';
import AncorsImg from '../imgs/sponsors/ancors-logo.png';
import BhpBillitonImg from '../imgs/sponsors/bhp-billiton.png';
import CreateNSWLogoImg from '../imgs/sponsors/creatensw-logo.png';
import DafImg from '../imgs/sponsors/daf-logo.png';
import GptImg from '../imgs/sponsors/gpt.png';
import IaccelerateImg from '../imgs/sponsors/iaccelerate-logo.jpg';
import MaterialsImg from '../imgs/sponsors/materials-logo.jpg';
import NationalTrustImg from '../imgs/sponsors/national-trust.png';
import NfsaImg from '../imgs/sponsors/nfsa.png';
import NswJobsImg from '../imgs/sponsors/nsw-jobs.png';
import NswMusGalImg from '../imgs/sponsors/nsw-mus-gal.png';
import NswTafeImg from '../imgs/sponsors/nsw-tafe.png';
import NswTradeImg from '../imgs/sponsors/nsw-trade.png';
import PackerFamilyImg from '../imgs/sponsors/packerfamily-logo.png';
import RotaryImg from '../imgs/sponsors/rotary.png';
import SbeImg from '../imgs/sponsors/sbe-logo.png';
import SecImg from '../imgs/sponsors/sec-logo.png';
import South32LogoImg from '../imgs/sponsors/south32-logo.jpg';
import UowImg from '../imgs/sponsors/uow.png';
import WCityInnovationImg from '../imgs/sponsors/w-city-innovation.png';

const PARTNERS = [
    { src: AusIMMLogoImg, alt: 'AusIMM' },
    { src: CrownResortsImg, alt: 'Crown Resorts Foundation' },
    { src: DWLogoImg, alt: 'DW' },
    { src: FnpwImg, alt: 'Foundation for National Parks & Wildlife' },
    { src: ImbLogoImg, alt: 'IMB' },
    { src: ItsowelImg, alt: 'Itsowel' },
    { src: NSWGovLogoImg, alt: 'NSW Government' },
    { src: OehImg, alt: 'Office of Environment and Heritage' },
    { src: AboriginalCorpImg, alt: 'Aboriginal Corporation' },
    { src: ActHeritageImg, alt: 'ACT Heritage' },
    { src: ActGovLogoImg, alt: 'ACT Government' },
    { src: AncorsImg, alt: 'ANCORS' },
    { src: BhpBillitonImg, alt: 'BHP' },
    { src: CreateNSWLogoImg, alt: 'Create NSW' },
    { src: DafImg, alt: 'Department of Agriculture and Fisheries' },
    { src: GptImg, alt: 'GPT' },
    { src: IaccelerateImg, alt: 'iAccelerate' },
    { src: MaterialsImg, alt: 'Materials' },
    { src: NationalTrustImg, alt: 'National Trust' },
    { src: NfsaImg, alt: 'National Film and Sound Archive' },
    { src: NswJobsImg, alt: 'NSW Jobs' },
    { src: NswMusGalImg, alt: 'Museums & Galleries of NSW' },
    { src: NswTafeImg, alt: 'TAFE NSW' },
    { src: NswTradeImg, alt: 'NSW Trade' },
    { src: PackerFamilyImg, alt: 'Packer Family Foundation' },
    { src: RotaryImg, alt: 'Rotary' },
    { src: SbeImg, alt: 'SBE' },
    { src: SecImg, alt: 'SEC' },
    { src: South32LogoImg, alt: 'South32' },
    { src: UowImg, alt: 'University of Wollongong' },
    { src: WCityInnovationImg, alt: 'Wollongong City of Innovation' },
];

const Partners = () => (
    <section className={style.partnersSection} id="partners">
        <div className="wrap">
            <div className="section-head" style={{ maxWidth: 600, margin: '0 auto 28px', textAlign: 'center' }}>
                <div className="eyebrow"></div>
                <h2>Our partners</h2>
            </div>
        </div>
        <div className={style.partnersMarquee}>
            <div className={style.partnersTrack}>
                {PARTNERS.map(p => (
                    <div className={style.partnersLogo} key={p.alt}>
                        <img src={p.src} alt={p.alt} />
                    </div>
                ))}
                {PARTNERS.map(p => (
                    <div className={style.partnersLogo} key={`${p.alt}-dup`} aria-hidden="true">
                        <img src={p.src} alt="" />
                    </div>
                ))}
            </div>
        </div>
    </section>
);

export default Partners;
